<style>
html, body {
  font-family: Roboto, Helvetica, Arial;
  font-size: 18px;
}
input {
  font-size: 20px;
  max-width: 90%;
  padding: 5px;
  margin: 10px auto;
}
</style>

<p>Paypal Style currency amount input:</p>
<form [formGroup]='form'>
  <input aria-label="Feld zur Eingabe des Betrags" data-nemo="amount" dir="ltr" autocomplete="off" type="tel" name="amount" id="fn-amount" required class="ppaf-input" currencyMask #amountInput formControlName="amount" [options]="{ prefix: '', thousands: '.', decimal: ',' }" (click)="onInputClick()">
</form>
